import { render, staticRenderFns } from "./inseranceLists.vue?vue&type=template&id=36b50a64&scoped=true&"
import script from "./inseranceLists.vue?vue&type=script&lang=js&"
export * from "./inseranceLists.vue?vue&type=script&lang=js&"
import style0 from "./inseranceLists.vue?vue&type=style&index=0&id=36b50a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b50a64",
  null
  
)

export default component.exports